import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList/DataList';

type Payload = { monthlyPayment: number; numberOfInstallments: number; redirectUrl: string };
type Props = ModalProps<Payload>;

const ChangeMonthlyPaymentSuccess = ({ payload }: Props) => {
  const { t } = useTranslation(['Modal', 'Common']);
  const { monthlyPayment, numberOfInstallments, redirectUrl } = payload;

  return (
    <Modal title={t('ChangeMonthlyPaymentSuccess.title')}>
      <div className="flex flex-col gap-8">
        <p>{t('ChangeMonthlyPaymentSuccess.info', { monthlyPayment })}</p>
        <DataList>
          <DataListItem>
            <DataListLabel>{t('ChangeMonthlyPaymentSuccess.listItemTitle')}</DataListLabel>
            <DataListValue>{t('Common:money', { amount: monthlyPayment })}</DataListValue>
          </DataListItem>
          <DataListItem>
            <DataListLabel>{t('ChangeMonthlyPaymentSuccess.numberOfInstallmentsLabel')}</DataListLabel>
            <DataListValue>
              {t('ChangeMonthlyPaymentSuccess.numberOfInstallmentsValue', {
                count: numberOfInstallments,
              })}
            </DataListValue>
          </DataListItem>
        </DataList>
      </div>
      <ModalActions>
        <LinkButton to={redirectUrl}>{t('ChangeMonthlyPaymentSuccess.button')}</LinkButton>
      </ModalActions>
    </Modal>
  );
};

export default ChangeMonthlyPaymentSuccess;
